import {User} from "../model/tutor/User";

export const MAX_NUMBER_OF_STUDENTS_FREE = 3;
export const MAX_NUMBER_OF_BOARDS_FREE = 15;

export function hasSubscriptionExpired(user: User): boolean {
    return new Date(user.subscriptionUntil).getTime() < new Date().getTime();
}
